export const en: Record<string, string> = {
  'users.title': 'Users',
  'users.description': 'Find people, check their onboarding and activity, and open their profile.',
  'users.search': 'Search users',
  'users.searchPlaceholder': 'Name, email, phone or user ID',
  'users.filters': 'Filters',
  'users.advancedFilters': 'Advanced user filters',
  'users.refresh': 'Refresh',
  'users.actions': 'User actions',
  'users.export': 'Export CSV',
  'users.exporting': 'Exporting…',
  'users.sync': 'Sync Auth0',
  'users.syncing': 'Syncing…',
  'users.synced': '{count} users synced.',
  'users.syncDetails': 'Checked {checked} Auth0 users, {existing} already existed, {skipped} skipped.',
  'users.syncSuccess': '{count} users synced from Auth0',
  'users.loadFailed': 'Users could not be loaded. Try refreshing.',
  'users.communitiesFailed': 'Communities could not be loaded.',
  'users.exportFailed': 'Users could not be exported. Try again.',
  'users.syncFailed': 'Auth0 users could not be synced. Try again.',
  'users.any': 'Any',
  'users.yes': 'Yes',
  'users.no': 'No',
  'users.clearFilters': 'Clear filters',
  'users.removeFilter': 'Remove filter: {filter}',
  'users.activeFilters': 'Active filters',
  'users.includeDeleted': 'Include deleted',
  'users.quick.recent': 'Active in the last 7 days',
  'users.quick.didit': 'Didit verified',
  'users.filter.activity': 'App activity',
  'users.activity.any': 'Any activity',
  'users.activity.24h': 'Last 24 hours',
  'users.activity.7d': 'Last 7 days',
  'users.activity.30d': 'Last 30 days',
  'users.activity.90d': 'Last 90 days',
  'users.activity.never': 'Not recorded',
  'users.filter.agbAccepted': 'Terms accepted',
  'users.filter.hasBio': 'Profile bio',
  'users.filter.diditVerified': 'Didit verification',
  'users.filter.hasVehicle': 'Vehicle added',
  'users.filter.stripe': 'Stripe Connect',
  'users.filter.hasCreatedRides': 'Rides created',
  'users.filter.hasCreatedRideRequests': 'Requests created',
  'users.filter.hasCompletedRides': 'Rides completed',
  'users.filter.hasCompletedRideRequests': 'Requests completed',
  'users.filter.community': 'Community',
  'users.filter.allCommunities': 'All communities',
  'users.filter.unavailableCommunity': 'Selected community (unavailable)',
  'users.filter.group': 'Group ID',
  'users.filter.groupPlaceholder': 'Group UUID',
  'users.filter.emailOptedOut': 'Email opt-out',
  'users.filter.hasSearches': 'Has searches',
  'users.filter.hasEmergencyContacts': 'Emergency contacts',
  'users.filter.hasReceivedReviews': 'Received reviews',
  'users.filter.hasGivenReviews': 'Given reviews',
  'users.filter.rating': 'Minimum average rating',
  'users.filters.profile': 'Profile and onboarding',
  'users.filters.rides': 'Rides and activity',
  'users.filters.community': 'Community and communication',
  'users.filters.reviews': 'Reviews and safety',
  'users.sort': 'Sort by',
  'users.sort.LAST_SEEN_AT': 'Last seen',
  'users.sort.CREATED_AT': 'Created',
  'users.sort.UPDATED_AT': 'Updated',
  'users.sort.EMAIL': 'Email',
  'users.direction': 'Sort direction',
  'users.direction.ASC': 'Ascending',
  'users.direction.DESC': 'Descending',
  'users.pageSize': 'Rows per page',
  'users.loading': 'Loading users…',
  'users.found': '{count} users found',
  'users.page': 'Page {page} of {total}',
  'users.table.person': 'Person',
  'users.table.onboarding': 'Onboarding',
  'users.table.verification': 'Verification and payments',
  'users.table.activity': 'Ride activity',
  'users.table.lastSeen': 'Last seen',
  'users.unknown': 'Unknown user',
  'users.noEmail': 'No email',
  'users.noPhone': 'No phone',
  'users.copyId': 'Copy user ID: {id}',
  'users.created': 'Created {date}',
  'users.deleted': 'Deleted',
  'users.deletedAt': 'Deleted {date}',
  'users.active': 'Active',
  'users.anonymized': 'Anonymized',
  'users.open': 'Open profile',
  'users.openFor': 'Open profile for {name}',
  'users.empty': 'No users match these filters. Adjust your search or clear the filters.',
  'users.previous': 'Previous',
  'users.next': 'Next',
  'users.onboarding.pending': 'Pending: {step}',
  'users.onboarding.COMPLETED': 'Completed',
  'users.onboarding.NAME': 'Name and birthday',
  'users.onboarding.PROFILE': 'Profile',
  'users.onboarding.TERMS': 'Terms',
  'users.onboarding.SOURCE': 'Acquisition source',
  'users.onboarding.EVENT': 'Event',
  'users.onboarding.COMMUNITY': 'Community',
  'users.onboarding.INTERESTS': 'Interests',
  'users.onboarding.USAGE': 'Usage',
  'users.onboarding.RIDE_PLAN': 'Ride plan',
  'users.onboarding.VEHICLE': 'Vehicle',
  'users.onboarding.VERIFICATION_CHOICE': 'Verification choice',
  'users.onboarding.VERIFICATION': 'Verification',
  'users.onboarding.STRIPE': 'Stripe',
  'users.onboarding.FINISH': 'Finish',
  'users.badge.terms': 'Terms',
  'users.badge.bio': 'Bio',
  'users.badge.didit': 'Didit',
  'users.badge.vehicle': 'Vehicle',
  'users.emailOptedOut': 'Optional emails: unsubscribed from all',
  'users.emailNotOptedOut': 'Optional emails: no general unsubscribe',
  'users.verification.VERIFIED': 'Verified',
  'users.verification.VERIFIED_DRIVER': 'Verified driver',
  'users.verification.NOT_VERIFIED': 'Not verified',
  'users.verification.OTHER': 'Other verification status',
  'users.stripe.READY': 'Ready',
  'users.stripe.IN_REVIEW': 'In review',
  'users.stripe.ONBOARDING_REQUIRED': 'Onboarding pending',
  'users.stripe.PAYOUTS_DISABLED': 'Payouts disabled',
  'users.stripe.NO_ACCOUNT': 'No account',
  'users.activity.created': 'Created',
  'users.activity.single': 'Single rides',
  'users.activity.recurring': 'Recurring rides',
  'users.activity.requests': 'Requests',
  'users.activity.completed': 'Completed',
  'users.activity.rides': 'Rides',
};

export const de: Record<string, string> = {
  'users.title': 'Nutzer',
  'users.description': 'Personen finden, Onboarding und Aktivität prüfen und ihr Profil öffnen.',
  'users.search': 'Nutzer suchen',
  'users.searchPlaceholder': 'Name, E-Mail, Telefon oder Nutzer-ID',
  'users.filters': 'Filter',
  'users.advancedFilters': 'Erweiterte Nutzerfilter',
  'users.refresh': 'Aktualisieren',
  'users.actions': 'Nutzeraktionen',
  'users.export': 'CSV exportieren',
  'users.exporting': 'Wird exportiert…',
  'users.sync': 'Auth0 synchronisieren',
  'users.syncing': 'Wird synchronisiert…',
  'users.synced': '{count} Nutzer synchronisiert.',
  'users.syncDetails': '{checked} Auth0-Nutzer geprüft, {existing} bereits vorhanden, {skipped} übersprungen.',
  'users.syncSuccess': '{count} Nutzer aus Auth0 synchronisiert',
  'users.loadFailed': 'Nutzer konnten nicht geladen werden. Bitte aktualisieren.',
  'users.communitiesFailed': 'Communities konnten nicht geladen werden.',
  'users.exportFailed': 'Nutzer konnten nicht exportiert werden. Bitte erneut versuchen.',
  'users.syncFailed': 'Auth0-Nutzer konnten nicht synchronisiert werden. Bitte erneut versuchen.',
  'users.any': 'Alle',
  'users.yes': 'Ja',
  'users.no': 'Nein',
  'users.clearFilters': 'Filter zurücksetzen',
  'users.removeFilter': 'Filter entfernen: {filter}',
  'users.activeFilters': 'Aktive Filter',
  'users.includeDeleted': 'Gelöschte einschließen',
  'users.quick.recent': 'In den letzten 7 Tagen aktiv',
  'users.quick.didit': 'Didit-verifiziert',
  'users.filter.activity': 'App-Aktivität',
  'users.activity.any': 'Jede Aktivität',
  'users.activity.24h': 'Letzte 24 Stunden',
  'users.activity.7d': 'Letzte 7 Tage',
  'users.activity.30d': 'Letzte 30 Tage',
  'users.activity.90d': 'Letzte 90 Tage',
  'users.activity.never': 'Nicht erfasst',
  'users.filter.agbAccepted': 'AGB akzeptiert',
  'users.filter.hasBio': 'Profilbeschreibung',
  'users.filter.diditVerified': 'Didit-Verifizierung',
  'users.filter.hasVehicle': 'Fahrzeug angelegt',
  'users.filter.stripe': 'Stripe Connect',
  'users.filter.hasCreatedRides': 'Fahrten erstellt',
  'users.filter.hasCreatedRideRequests': 'Fahrtwünsche erstellt',
  'users.filter.hasCompletedRides': 'Fahrten abgeschlossen',
  'users.filter.hasCompletedRideRequests': 'Fahrtwünsche abgeschlossen',
  'users.filter.community': 'Community',
  'users.filter.allCommunities': 'Alle Communities',
  'users.filter.unavailableCommunity': 'Gewählte Community (nicht verfügbar)',
  'users.filter.group': 'Gruppen-ID',
  'users.filter.groupPlaceholder': 'Gruppen-UUID',
  'users.filter.emailOptedOut': 'E-Mail-Abmeldung',
  'users.filter.hasSearches': 'Suchen vorhanden',
  'users.filter.hasEmergencyContacts': 'Notfallkontakte',
  'users.filter.hasReceivedReviews': 'Erhaltene Bewertungen',
  'users.filter.hasGivenReviews': 'Abgegebene Bewertungen',
  'users.filter.rating': 'Mindestdurchschnittsbewertung',
  'users.filters.profile': 'Profil und Onboarding',
  'users.filters.rides': 'Fahrten und Aktivität',
  'users.filters.community': 'Community und Kommunikation',
  'users.filters.reviews': 'Bewertungen und Sicherheit',
  'users.sort': 'Sortieren nach',
  'users.sort.LAST_SEEN_AT': 'Zuletzt aktiv',
  'users.sort.CREATED_AT': 'Erstellt',
  'users.sort.UPDATED_AT': 'Aktualisiert',
  'users.sort.EMAIL': 'E-Mail',
  'users.direction': 'Sortierrichtung',
  'users.direction.ASC': 'Aufsteigend',
  'users.direction.DESC': 'Absteigend',
  'users.pageSize': 'Zeilen pro Seite',
  'users.loading': 'Nutzer werden geladen…',
  'users.found': '{count} Nutzer gefunden',
  'users.page': 'Seite {page} von {total}',
  'users.table.person': 'Person',
  'users.table.onboarding': 'Onboarding',
  'users.table.verification': 'Verifizierung und Zahlungen',
  'users.table.activity': 'Fahrtaktivität',
  'users.table.lastSeen': 'Zuletzt aktiv',
  'users.unknown': 'Unbekannter Nutzer',
  'users.noEmail': 'Keine E-Mail',
  'users.noPhone': 'Kein Telefon',
  'users.copyId': 'Nutzer-ID kopieren: {id}',
  'users.created': 'Erstellt {date}',
  'users.deleted': 'Gelöscht',
  'users.deletedAt': 'Gelöscht {date}',
  'users.active': 'Aktiv',
  'users.anonymized': 'Anonymisiert',
  'users.open': 'Profil öffnen',
  'users.openFor': 'Profil von {name} öffnen',
  'users.empty': 'Keine Nutzer für diese Filter. Suche anpassen oder Filter zurücksetzen.',
  'users.previous': 'Zurück',
  'users.next': 'Weiter',
  'users.onboarding.pending': 'Ausstehend: {step}',
  'users.onboarding.COMPLETED': 'Abgeschlossen',
  'users.onboarding.NAME': 'Name und Geburtsdatum',
  'users.onboarding.PROFILE': 'Profil',
  'users.onboarding.TERMS': 'AGB',
  'users.onboarding.SOURCE': 'Akquisequelle',
  'users.onboarding.EVENT': 'Event',
  'users.onboarding.COMMUNITY': 'Community',
  'users.onboarding.INTERESTS': 'Interessen',
  'users.onboarding.USAGE': 'Nutzungsart',
  'users.onboarding.RIDE_PLAN': 'Fahrtplan',
  'users.onboarding.VEHICLE': 'Fahrzeug',
  'users.onboarding.VERIFICATION_CHOICE': 'Verifizierungsart',
  'users.onboarding.VERIFICATION': 'Verifizierung',
  'users.onboarding.STRIPE': 'Stripe',
  'users.onboarding.FINISH': 'Abschluss',
  'users.badge.terms': 'AGB',
  'users.badge.bio': 'Bio',
  'users.badge.didit': 'Didit',
  'users.badge.vehicle': 'Fahrzeug',
  'users.emailOptedOut': 'Optionale E-Mails: allgemein abgemeldet',
  'users.emailNotOptedOut': 'Keine allgemeine E-Mail-Abmeldung',
  'users.verification.VERIFIED': 'Verifiziert',
  'users.verification.VERIFIED_DRIVER': 'Verifizierter Fahrer',
  'users.verification.NOT_VERIFIED': 'Nicht verifiziert',
  'users.verification.OTHER': 'Anderer Verifizierungsstatus',
  'users.stripe.READY': 'Bereit',
  'users.stripe.IN_REVIEW': 'In Prüfung',
  'users.stripe.ONBOARDING_REQUIRED': 'Onboarding ausstehend',
  'users.stripe.PAYOUTS_DISABLED': 'Auszahlungen deaktiviert',
  'users.stripe.NO_ACCOUNT': 'Kein Konto',
  'users.activity.created': 'Erstellt',
  'users.activity.single': 'Einzelfahrten',
  'users.activity.recurring': 'Serienfahrten',
  'users.activity.requests': 'Fahrtwünsche',
  'users.activity.completed': 'Abgeschlossen',
  'users.activity.rides': 'Fahrten',
};
